/* IndiasBuy shopping tools: Product Finder and Compare. Data comes from the live catalogue (snippet ib-products-json). */
(function () {
  'use strict';

  var BRANDS = [
    ['Apple', /^\s*apple\b/i], ['boAt', /^\s*boat\b/i], ['Boult', /^\s*boult\b/i], ['Fastrack', /^\s*fastrack\b/i],
    ['Jabra', /^\s*jabra\b/i], ['JBL', /^\s*jbl\b/i], ['Noise', /^\s*noise\b/i], ['OnePlus', /^\s*oneplus\b/i],
    ['realme', /^\s*realme\b/i], ['Redmi (Xiaomi)', /^\s*redmi\b/i], ['Samsung', /^\s*samsung\b/i], ['Skullcandy', /^\s*skullcandy\b/i]
  ];
  var TYPE_LABEL = { earbuds: 'Wireless earbuds', headphones: 'Headphones', neckband: 'Neckband', smartwatch: 'Smartwatch', other: 'Other' };
  var FEATURES = [
    ['anc', 'Active noise cancellation', /noise cancel|\bANC\b/i],
    ['latency', 'Low latency / gaming mode', /latency|gaming/i],
    ['spatial', 'Spatial audio', /spatial/i],
    ['calling', 'Bluetooth calling', /calling/i],
    ['enc', 'Call noise reduction (ENC/ENx)', /\bENC\b|\bENx\b|AI Noise Reduction/i],
    ['multipoint', 'Dual pairing / dual device', /dual (pairing|device)/i],
    ['fastcharge', 'Fast charging', /fast charg|rapid charg|quick charg/i],
    ['amoled', 'AMOLED display', /amoled/i],
    ['gps', 'Built-in GPS', /\bGPS\b/i]
  ];
  function fmt(paise) { return 'Rs. ' + Math.round((paise || 0) / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function enrich(p) {
    var t = p.title || '';
    var ty = (p.type || '').toLowerCase();
    p.kind = /earbud|airpod/.test(ty) ? 'earbuds' : /headphone/.test(ty) ? 'headphones' : /watch/.test(ty) ? 'smartwatch' : /neckband/.test(ty) ? 'neckband'
      : /watch/i.test(t) ? 'smartwatch' : /neckband/i.test(t) ? 'neckband' : /headphone/i.test(t) ? 'headphones' : /earbud|tws|buds/i.test(t) ? 'earbuds' : 'other';
    p.brand = 'Other';
    for (var i = 0; i < BRANDS.length; i++) { if (BRANDS[i][1].test(t)) { p.brand = BRANDS[i][0]; break; } }
    p.condition = /unboxed|open\s?box|openbox/i.test(t) ? 'unboxed' : /brand new|fresh pack/i.test(t) ? 'new' : 'unspecified';
    p.features = {};
    FEATURES.forEach(function (f) { p.features[f[0]] = f[2].test(t); });
    p.off = p.compare > p.price && p.compare > 0 ? Math.round((1 - p.price / p.compare) * 100) : 0;
    var sh = (t.split('|')[0].split(',')[0] || t).replace(/\s*-\s*(unboxed|brand new|openbox|fresh pack)\s*$/i, '').replace(/\s*\((black|bold black|starry blue|yellow)\)\s*$/i, '').trim();
    if ((sh.match(/\(/g) || []).length !== (sh.match(/\)/g) || []).length) sh = sh.split('(')[0].trim();
    p.short = sh;
    return p;
  }

  function loadData(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try { return JSON.parse(el.textContent).map(enrich); } catch (e) { console.error('ib-tools: bad product data', e); return []; }
  }

  function conditionChip(p) {
    if (p.condition === 'unboxed') return '<span class="ib-chip ib-chip--accent">Unboxed</span>';
    if (p.condition === 'new') return '<span class="ib-chip ib-chip--ok">Brand new</span>';
    return '';
  }

  function addToCart(btn, variantId) {
    if (!variantId) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ib-tools', data: { itemCount: cart.item_count, source: 'ib-tools' } } }));
        var link = btn.parentNode.querySelector('[data-go-cart]');
        if (link) link.hidden = false;
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
      })
      .catch(function () { btn.textContent = 'Could not add – open product'; btn.disabled = false; });
  }

  function card(p) {
    var kind = { earbuds: 'Earbuds', headphones: 'Headphones', neckband: 'Neckband', smartwatch: 'Smartwatch', other: 'Audio' }[p.kind];
    var cond = p.condition === 'unboxed' ? '<p class="ib-pc__cond"><span class="ib-chip ib-chip--accent">Unboxed</span></p>'
      : p.condition === 'new' ? '<p class="ib-pc__cond"><span class="ib-chip ib-chip--ok">Brand new</span></p>' : '';
    return '<li><div class="ib-pc">' +
      '<a class="ib-media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="480" height="480">' : '') + '</a>' +
      (p.off ? '<span class="ib-pc__badge">-' + p.off + '%</span>' : '') + (p.available ? '' : '<span class="ib-pc__soldout">Sold out</span>') +
      '<div class="ib-pc__body"><p class="ib-pc__meta">' + esc(p.brand) + ' · ' + kind + '</p>' +
      '<h3 class="ib-pc__title"><a href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + esc(p.short) + '</a></h3>' + cond +
      '<div class="ib-pc__price"><span class="ib-pc__now">' + fmt(p.price) + '</span>' + (p.off ? '<s>' + fmt(p.compare) + '</s>' : '') + '</div></div>' +
      '<div class="ib-pc__actions">' +
      (p.available && p.variantAvailable ? '<button type="button" class="ib-btn ib-btn--sm" data-add="' + p.variant + '">Add to cart</button>' : '') +
      '<a class="ib-btn ib-btn--sm ib-btn--ghost" href="/pages/compare-products?p=' + encodeURIComponent(p.handle) + '">Compare</a>' +
      '<a href="/cart" data-go-cart hidden class="ib-link">Go to cart</a></div></div></li>';
  }

  /* ---------------- Product Finder ---------------- */
  function initFinder(root) {
    var data = loadData(root.getAttribute('data-source'));
    var form = root.querySelector('[data-finder-form]');
    var list = root.querySelector('[data-results]');
    var count = root.querySelector('[data-count]');
    var brandSel = form.querySelector('select[name="brand"]');
    var brands = Array.from(new Set(data.map(function (p) { return p.brand; }))).sort(function (a, b) { return a.localeCompare(b); });
    brands.forEach(function (b) { var o = document.createElement('option'); o.value = b; o.textContent = b; brandSel.appendChild(o); });

    var params = new URLSearchParams(location.search);
    params.forEach(function (val, key) {
      form.querySelectorAll('[name="' + key + '"]').forEach(function (inp) {
        if (inp.type === 'radio' || inp.type === 'checkbox') { if (val.split(',').indexOf(inp.value) > -1) inp.checked = true; }
        else inp.value = val;
      });
    });

    function state() {
      var fd = new FormData(form);
      return {
        type: fd.get('type') || 'any', budget: fd.get('budget') || 'any', condition: fd.get('condition') || 'any',
        brand: fd.get('brand') || 'any', feat: fd.getAll('feat'), instock: !!fd.get('instock'), sort: fd.get('sort') || 'match'
      };
    }

    function render() {
      var s = state();
      var out = data.filter(function (p) {
        if (s.type !== 'any' && p.kind !== s.type) return false;
        if (s.budget !== 'any') {
          var r = s.budget.split('-'); var min = +r[0] * 100; var max = r[1] ? +r[1] * 100 : Infinity;
          if (p.price < min || p.price > max) return false;
        }
        if (s.condition !== 'any' && p.condition !== s.condition) return false;
        if (s.brand !== 'any' && p.brand !== s.brand) return false;
        for (var i = 0; i < s.feat.length; i++) { if (!p.features[s.feat[i]]) return false; }
        if (s.instock && !p.available) return false;
        return true;
      });
      out.sort(function (a, b) {
        if (s.sort === 'price-asc') return a.price - b.price;
        if (s.sort === 'price-desc') return b.price - a.price;
        if (s.sort === 'discount') return b.off - a.off;
        return (b.available - a.available) || (b.off - a.off);
      });
      count.textContent = out.length === 1 ? '1 product matches' : out.length + ' products match';
      list.innerHTML = out.length ? out.map(card).join('') :
        '<li class="ib-empty">No products match all of these choices. Try removing a feature or widening the budget.</li>';
      var q = new URLSearchParams();
      Object.keys(s).forEach(function (k) {
        var v = s[k];
        if (Array.isArray(v)) { if (v.length) q.set(k, v.join(',')); }
        else if (v === true) q.set(k, '1');
        else if (v && v !== 'any' && v !== 'match' && v !== false) q.set(k, v);
      });
      history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q.toString() : ''));
    }

    form.addEventListener('change', render);
    form.addEventListener('submit', function (e) { e.preventDefault(); render(); });
    root.querySelector('[data-reset]').addEventListener('click', function () { form.reset(); render(); });
    list.addEventListener('click', function (e) { var b = e.target.closest('[data-add]'); if (b) addToCart(b, +b.getAttribute('data-add')); });
    render();
  }

  /* ---------------- Compare ---------------- */
  function initCompare(root) {
    var data = loadData(root.getAttribute('data-source'));
    var byHandle = {};
    data.forEach(function (p) { byHandle[p.handle] = p; });
    var selects = Array.from(root.querySelectorAll('[data-compare-select]'));
    var out = root.querySelector('[data-compare-out]');
    var sorted = data.slice().sort(function (a, b) { return (TYPE_LABEL[a.kind] + a.brand + a.short).localeCompare(TYPE_LABEL[b.kind] + b.brand + b.short); });
    selects.forEach(function (sel) {
      var group = null, og = null;
      sorted.forEach(function (p) {
        if (group !== p.kind) { group = p.kind; og = document.createElement('optgroup'); og.label = TYPE_LABEL[p.kind]; sel.appendChild(og); }
        var o = document.createElement('option'); o.value = p.handle; o.textContent = p.brand + ' – ' + p.short; og.appendChild(o);
      });
    });
    var pre = (new URLSearchParams(location.search).get('p') || '').split(',').filter(function (h) { return byHandle[h]; });
    pre.slice(0, selects.length).forEach(function (h, i) { selects[i].value = h; });

    function yes(v) { return v ? '<span class="ib-yes">✓ Listed</span>' : '<span class="ib-muted">—</span>'; }

    function render() {
      var picked = selects.map(function (s) { return byHandle[s.value]; }).filter(Boolean);
      var q = picked.map(function (p) { return p.handle; }).join(',');
      history.replaceState(null, '', location.pathname + (q ? '?p=' + encodeURIComponent(q).replace(/%2C/g, ',') : ''));
      if (picked.length < 2) {
        out.innerHTML = '<div class="ib-empty">Choose at least two products above to see them side by side.</div>';
        return;
      }
      var rows = [
        ['Product', function (p) { return (p.image ? '<span class="ib-media" style="margin-bottom:10px"><img src="' + esc(p.image) + '" alt="" loading="lazy" width="240" height="240"></span>' : '') + '<a href="' + esc(p.url) + '"><strong>' + esc(p.short) + '</strong></a>'; }],
        ['Price', function (p) { return '<strong>' + fmt(p.price) + '</strong>'; }],
        ['MRP / compare-at', function (p) { return p.off ? '<s>' + fmt(p.compare) + '</s>' : '<span class="ib-muted">—</span>'; }],
        ['You save', function (p) { return p.off ? fmt(p.compare - p.price) + ' (' + p.off + '%)' : '<span class="ib-muted">—</span>'; }],
        ['Brand', function (p) { return esc(p.brand); }],
        ['Category', function (p) { return esc(TYPE_LABEL[p.kind]); }],
        ['Condition', function (p) { return p.condition === 'unboxed' ? 'Unboxed (open-box)' : p.condition === 'new' ? 'Brand new' : 'See product page'; }],
        ['Colour options', function (p) { return p.colours ? esc(p.colours) : '<span class="ib-muted">—</span>'; }]
      ];
      FEATURES.forEach(function (f) { rows.push([f[1], function (p) { return yes(p.features[f[0]]); }]); });
      rows.push(['Availability', function (p) { return p.available ? '<span class="ib-yes">In stock</span>' : 'Sold out'; }]);
      rows.push(['Highlights', function (p) { return '<span style="font-size:.88rem">' + esc(p.desc) + '</span>'; }]);
      rows.push(['', function (p) {
        return '<a class="ib-btn ib-btn--sm ib-btn--ghost" href="' + esc(p.url) + '">View</a> ' +
          (p.available && p.variantAvailable ? '<button type="button" class="ib-btn ib-btn--sm" data-add="' + p.variant + '">Add to cart</button>' : '') +
          ' <a href="/cart" data-go-cart hidden class="ib-link">Go to cart</a>';
      }]);
      var html = '<div class="ib-compare__scroll"><table><caption class="ib-visually-hidden">Product comparison</caption><thead><tr><th scope="col"><span class="ib-visually-hidden">Attribute</span></th>' +
        picked.map(function (p) { return '<th scope="col">' + esc(p.brand) + '</th>'; }).join('') + '</tr></thead><tbody>' +
        rows.map(function (r) { return '<tr><th scope="row">' + esc(r[0]) + '</th>' + picked.map(function (p) { return '<td>' + r[1](p) + '</td>'; }).join('') + '</tr>'; }).join('') +
        '</tbody></table></div><p class="ib-sub" style="font-size:.84rem">✓ Listed = the feature is named in the product listing. — = not named in the listing title; open the product page for full specifications.</p>';
      out.innerHTML = html;
    }
    selects.forEach(function (s) { s.addEventListener('change', render); });
    out.addEventListener('click', function (e) { var b = e.target.closest('[data-add]'); if (b) addToCart(b, +b.getAttribute('data-add')); });
    render();
  }

  function boot() {
    document.querySelectorAll('[data-ib-finder]').forEach(initFinder);
    document.querySelectorAll('[data-ib-compare]').forEach(initCompare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
